export default function Icon({
  src,
  className,
  alt,
}: {
  src?: string;
  className?: string;
  alt?: string;
}) {
  return (
    <img className={className} src={src} alt={alt ?? ""} loading={"eager"} />
  );
}
